import { environmentContext } from './environmentContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnvironmentProvider = ({
  children,
  ...contextValue
}) => /*#__PURE__*/_jsx(environmentContext.Provider, {
  value: contextValue,
  children: children
});
//# sourceMappingURL=EnvironmentProvider.js.map